import React from 'react'
import {
  Link
} from "react-router-dom";

const Footer = () => {
  return (
    <footer style={{background: '#151515'}} className="text-white">
      <div className="container mx-auto pt-16 pb-6 lg:pb-24 lg:pt-24">
        <div className="flex flex-wrap -mx-2 lg:-mx-4 text-xs lg:text-sm">
          {/* <div className="w-full lg:w-4/12 px-2 lg:px-4 mb-10 lg:mb-0">
            <div className="flex items-center text-white">
              <div className={`mr-3`}>
                <Link to="/">
                  <img src="/images/bnpt_logo.png" alt="BNPT" className="header__logo"/>
                </Link>
              </div>
              <div>
                <h1 className="text-4xl mr-3 font-bold">i-KHUB</h1>
              </div>
              <div style={{maxWidth: '129px', fontSize: '8px'}} className="leading-tight">
                <p>Pusat Informasi Penanggulangan Terorisme dan Ekstremisme Kekerasan</p>
              </div>
            </div>
          </div> */}
          <div className="w-full lg:w-5/12 px-2 lg:px-4 mb-10 lg:mb-0 lg:mr-auto">
            <p className="text-sm">K-Hub Penanggulangan Terorisme dan Ekstremisme berbasis Kekerasan merupakan mekanisme antar Kementerian/Lembaga, dan Mitra Pembangunan terkait upaya-upaya penanggulangan terorisme dan ekstremisme berbasis kekerasan dengan memanfaatkan platform teknologi informasi dalam pelaksanaan koordinasi, pengawasan dan pelaporan secara akuntabel, transparan dan partisipatif.</p>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0">
            <ul>
              <li className="mb-4">
                <Link to="/">Home</Link>
              </li>
              <li className="mb-4">
                <Link to="/about">About Us</Link>
              </li>
              <li className="mb-4">
                <Link to="/region-map">Peta<br/>Penanggulangan</Link>
              </li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0 order-4 lg:order-3">
            <ul>
              <li className="mb-4">
                <Link to="/resource">Products</Link>
              </li>
              <li className="mb-4">
                <Link to="/event">Events</Link>
              </li>
              <li className="mb-4">
                <Link to="/blog">Blog</Link>
              </li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0 lg:order-4">
            <ul>
              {/* <li className="mb-4">API</li> */}
              <li className="mb-4">
                <Link to="/contact">Contact Us</Link>
              </li>
              <li className="mb-4">
                <Link to="/faq">FAQ</Link>
              </li>
              <li className="mb-4">
                <Link to="/terms-conditions">Privacy &amp; Terms</Link>
              </li>
            </ul>
          </div>
          {/* <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0 order-5">
            <ul>
              <li>Instagram</li>
              <li>Facebook</li>
              <li>Youtube</li>
            </ul>
          </div> */}
        </div>
      </div>
      <div className="container mx-auto">
        <div className="pb-10 lg:pb-5 py-5 border-gray-800 border-t">
          <p className="text-xs" style={{color: '#666'}}>
            © Copyright 2020 I-KHub - Pusat Informasi dan Kolaborasi Pencegahan dan Penanggulangan Terorisme dan Ekstremisme
          </p>
        </div>
      </div>
    </footer>
  )
}

export { Footer }
